import { z } from 'zod';
import { FortemSDKValidationError } from './errors';
export const parseInput = (schema, input) => {
    const result = schema.safeParse(input);
    if (!result.success) {
        console.log(result.error);
        throw new FortemSDKValidationError(z.treeifyError(result.error));
    }
    return result.data;
};
